import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LucideIconInput } from '@lucide/angular';
import { IconComponent } from '../icon/icon.component';

export interface ViewToggleOption<T = string> {
  value: T;
  icon: LucideIconInput;
  label: string;
}

@Component({
  selector: 'ptl-view-toggle',
  standalone: true,
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ptl-view-toggle" role="group" [attr.aria-label]="groupLabel()">
      @for (option of options(); track option.value) {
        <button
          type="button"
          class="ptl-view-toggle__btn"
          [class.is-active]="option.value === value()"
          [attr.aria-label]="option.label"
          [attr.aria-pressed]="option.value === value()"
          [attr.title]="option.label"
          (click)="select(option)"
        >
          <ptl-icon [icon]="option.icon" size="s"></ptl-icon>
        </button>
      }
    </div>
  `,
  styleUrls: ['./ptl-view-toggle.component.scss'],
})
export class PtlViewToggleComponent<T = string> {
  options = input.required<ViewToggleOption<T>[]>();
  value = input.required<T>();
  groupLabel = input<string>('');

  valueChange = output<T>();

  protected select(option: ViewToggleOption<T>): void {
    if (option.value !== this.value()) {
      this.valueChange.emit(option.value);
    }
  }
}
